export const PORTAL_USUARIO_CRIAR = 'PORTAL_USUARIO_CRIAR';
export const PORTAL_USUARIO_EDITAR = 'PORTAL_USUARIO_EDITAR';
export const PORTAL_USUARIO_VISUALIZAR = 'PORTAL_USUARIO_VISUALIZAR';
export const PORTAL_USUARIO_REMOVER = 'PORTAL_USUARIO_REMOVER';
export const PORTAL_HIERARQUIA_VISUALIZAR = 'PORTAL_HIERARQUIA_VISUALIZAR';
export const PORTAL_HIERARQUIA_EXPORTAR = 'PORTAL_HIERARQUIA_EXPORTAR';
export const PORTAL_HIERARQUIA_EDITAR_EM_LOTE = 'PORTAL_HIERARQUIA_EDITAR_EM_LOTE';
export const PORTAL_LIDER_OI_VISUALIZAR = 'PORTAL_LIDER_OI_VISUALIZAR';
export const PORTAL_LIDER_OI_CRIAR = 'PORTAL_LIDER_OI_CRIAR';
export const PORTAL_LIDER_OI_EDITAR = 'PORTAL_LIDER_OI_EDITAR';
export const PORTAL_LIDER_OI_REMOVER = 'PORTAL_LIDER_OI_REMOVER';
export const PORTAL_AUDITORIA_VISUALIZAR = 'PORTAL_AUDITORIA_VISUALIZAR';
export const PORTAL_MENSAGEM_VISUALIZAR = 'PORTAL_MENSAGEM_VISUALIZAR';
export const PORTAL_MENSAGEM_CRIAR = 'PORTAL_MENSAGEM_CRIAR';
export const PORTAL_AVISOS_VISUALIZAR = 'PORTAL_AVISOS_VISUALIZAR';
export const PORTAL_TREINAMENTOS_VISUALIZAR = 'PORTAL_TREINAMENTOS_VISUALIZAR';
export const PORTAL_TREINAMENTOS_EXPORTAR = 'PORTAL_TREINAMENTOS_EXPORTAR';
export const PORTAL_SAUDE_VISUALIZAR = 'PORTAL_SAUDE_VISUALIZAR';
export const PORTAL_EQUIPAMENTOS_VISUALIZAR = 'PORTAL_EQUIPAMENTOS_VISUALIZAR';
export const PORTAL_EQUIPAMENTOS_EXPORTAR = 'PORTAL_EQUIPAMENTOS_EXPORTAR';
export const PORTAL_STATUSTECNICOS_VISUALIZAR = 'PORTAL_STATUSTECNICOS_VISUALIZAR';
export const PORTAL_CONHECIMENTO_VISUALIZAR = 'PORTAL_CONHECIMENTO_VISUALIZAR';
export const PORTAL_CONHECIMENTO_CRIAR = 'PORTAL_CONHECIMENTO_CRIAR';
